import styled from 'styled-components/macro';

export const WizardSubtotal = styled.div`
  display: flex;
  justify-content: space-between;
  height: 24px;
`;
